module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-results"
  }, [_c('i', {
    staticClass: "icon icon-no-results"
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.tip || '没有相关内容'))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329f4588","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/no-data.vue
// module id = KbeX
// module chunks = 6